export const URLGenerator = () => {
    const oneLinkURL = "https://prit-business.onelink.me/Mxb0?pid=User_invite&deep_link_value=ab72b843be1948b0c72b2fbaa99d77b7";

    return oneLinkURL;
};